module.exports = __webpack_public_path__ + "static/media/Logo-White.81a25ea2.png";